export const isValidFile = (
  mimeType?: string,
  validMimeTypes: string[] = [],
) => {
  if (!mimeType) return false;
  if (!validMimeTypes.length) return true;
  return validMimeTypes.some((validMimeType) =>
    mimeType.startsWith(validMimeType),
  );
};
